// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GCPillbutton {
  background-color: #007bff;
  border: none;
  outline: none;
  border-radius: 9999px !important;
  color:white;
  padding: 0.75em 0.75em;
  margin: 0.25em;
  font-size: 12px;
  cursor: pointer;
   transition: background-color 0.3s ease, color 0.3s ease;
}
  
  .GCPillbutton:hover {
    background-color: #0095ff;
    color: white;
  }
  
.GCPillbutton:active {
    background-color: #004494;
    border-color: #0056b3;
  }
  
  .GCPillbutton:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
  }`, "",{"version":3,"sources":["webpack://./src/css/GCPillButton.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,eAAe;GACd,uDAAuD;AAC1D;;EAEE;IACE,yBAAyB;IACzB,YAAY;EACd;;AAEF;IACI,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,4CAA4C;EAC9C","sourcesContent":[".GCPillbutton {\n  background-color: #007bff;\n  border: none;\n  outline: none;\n  border-radius: 9999px !important;\n  color:white;\n  padding: 0.75em 0.75em;\n  margin: 0.25em;\n  font-size: 12px;\n  cursor: pointer;\n   transition: background-color 0.3s ease, color 0.3s ease;\n}\n  \n  .GCPillbutton:hover {\n    background-color: #0095ff;\n    color: white;\n  }\n  \n.GCPillbutton:active {\n    background-color: #004494;\n    border-color: #0056b3;\n  }\n  \n  .GCPillbutton:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
